<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/ZDs4Kr/tc-custom/9780743218337.jpg?1730493406418" alt="This image is the cover for the book Hollywood Wives: The New Generation, The Hollywood Series"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Hollywood Wives: The New Generation, The Hollywood Series
      </h1>
      <p class="bookDescription body article font2">
        <b>“Luststyles of the rich and famous” propel this sexy page-turner that picks up where the #1 <i>New York Times</i>–bestselling <i>Hollywood Wives</i> left off (<i>People</i>).</b><br/><br/>Power. Sex. Money. Fame. The new Hollywood wives have it all. And if they don’t have it—they want it. And whatever these women want—they get.<br/><br/>Ambitious, young, smart, and lethal, the Hollywood wives are back with a vengeance, pushing their way to the forefront. Forget shopping—they’re into achieving everything their famous husbands have and more, and they don’t care how they do it.<br/><br/>“[This] glam take on celebrity fashion and open sexuality make it perfect fodder for our <i>Sex and the City </i>era.” —<i>Entertainment Weekly</i><br/><br/>“Sizzling . . . Collins dishes up glamour, suspense, and heartache.” —<i>Good Housekeeping</i><br/><br/>“Collins is a natural-born storyteller, a writer with an instinctive gift for racing narrative that is as willfully chaotic as anything in life.” —<i>Los Angeles Times</i><br/><br/> “This is Collins at her ultra-celeb, super-accessorized, bestselling best.” —<i>Publishers Weekly</i><br/><br/>“Nothing screams ‘summer reading’ like a novel with these three words somewhere on the spine: Hollywood, Wives, and Collins.” —<i>Booklist</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Jackie Collins
      </h2>
      
      <p class="authorDescription body article">Jackie Collins has been called a &ldquo;raunchy moralist&rdquo; by the director Louis Malle and &ldquo;Hollywood&rsquo;s own Marcel Proust&rdquo; by&#160;<I>Vanity Fair</I>. With over 500 million copies&#160;of her books sold in more than forty countries, and with thirty-two&#160;<I>New York Times</I>&#160;bestsellers to her credit, she is one of the world&rsquo;s top-selling novelists. Six of her novels have been adapted for film or TV. Collins was awarded an OBE (Order of the British Empire) by the Queen of England in 2013 for her services to literature and charity. When accepting the honor she said to the Queen, &ldquo;Not bad for a school drop-out&rdquo;&mdash;a revelation capturing her belief that both passion and determination can lead to big dreams coming true. She lived in Beverly Hills where she had a front-row seat to the lives she so accurately captured in her compulsive plotlines. She was a creative force, a trailblazer for women in fiction, and in her own words &ldquo;a kick-ass writer!&rdquo;&#160;Her fascinating life as a writer and icon is explored in the CNN Films and Netflix documentary&#160;<I>Lady Boss: The Jackie Collins Story.</I> Discover more at JackieCollins.com.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Gallery
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?abedf0ae